import request from '@/utils/request';

// 二维码信息数据页查询
export function qrcodeDataPage(values) {
  return request('/wechat/mp/qrcodeDataPage', {
    method: 'POST',
    data: values,
  });
}
